import React from "react";
import PropTypes from "prop-types";
import CheckIcon from "./checkIcon";

function WBMSelectionCard(props) {
    const onClick = (e) => {
        e.preventDefault();

        if (props.onClick && !props.disabled) {
            props.onClick(props.selectedId);
        }
    };

    let radioButtonClass = "";
    let cardClass = "row mx-0 align-items-center selection-card";

    if(props.disabled){
        cardClass += " disabled";
    }
    else if (props.selected) {
        radioButtonClass += "active";
        cardClass += " selected";
    }

    const onKeyDown = (e) => {
        if (e.key === "Enter") {
            onClick(e);
        }
    };

    return (
        <div
            onClick={onClick}
            className={cardClass}
            id={props.id}
            tabIndex={0}
            onKeyDown={onKeyDown}
        >
            <div className="col">
                <div className="row">
                    <div className="col-8">{props.children}</div>
                    <div className="col-4 text-right my-auto h-100">
                        {!props.cardExpired && <CheckIcon className={"check-icon " + radioButtonClass} />}
                        {props.cardExpired && <span className="expired-badge">Expired</span>}
                    </div>
                </div>
                {props.subDisplay && (
                    <div className="row subDisplay">
                        <div className="col">
                            <hr />
                            {props.subDisplay}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}

WBMSelectionCard.propTypes = {
    onClick: PropTypes.func.isRequired,
    selected: PropTypes.bool.isRequired,
    selectedId: PropTypes.string.isRequired,
    subDisplay: PropTypes.element,
    cardExpired: PropTypes.bool,
    disabled: PropTypes.bool
};

export default WBMSelectionCard;
